// 企业信息
export default {
    companyName: 'Название организации',
    administrator: 'администратор',
    contactInformation: 'Контакты',
    authorizationModule: 'Модуль авторизации',
    logoSettings: 'настройки логотипа',
    logoUpload: 'загрузка логотипа',
    imageFormatWrong: 'Загруженное изображение имеет неверный формат',
}
